module.exports = __webpack_public_path__ + "static/img/zxyt.ea8daa9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/zxyt.png
// module id = rEfM
// module chunks = 0